<template>
    <div class=" mb-3">
        <label class=" form-label" v-if="label">{{ label }}</label>
        <div class="form-check form-check-inline">
            <input type="checkbox" class="form-check-input" :name="name" :id="id" :value="modelValue"
                @change="handleChange" :checked="modelValue" />
            <label class="form-check-label" :class="textColor" :style="`color:${textColor}`" :for="id">{{ text }} 
            </label>
        </div>

    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'DynamicCheckbox',
    props: {
        label: {
            type: String
        },
        text: {
            type: String
        },
        modelValue: {
            type: Boolean
        },
        name: {
            type: String
        },
        id: {
            type: String
        },
        textColor: {
            type: String
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const handleChange = (event) => {
            const newValue = event.target.checked ? 1 : 0;
            emit('update:modelValue', newValue);
        };

        return {
            handleChange
        };
    }
});
</script>

<style scoped>
/* Add your styles here */
</style>
